(function () {
  'use strict';
  if (window.CaremaSFY) return;

  var STOREFRONT_URL = window.location.origin + '/api/2024-01/graphql.json';
  var STOREFRONT_TOKEN = '7fad72fcbf356bf1370aaa6bb446b9d8';
  var CACHE_KEY = 'carema_sfy_looks_v1';
  var CACHE_TTL = 300000;
  var PAGE_SIZE = 50;

  var FALLBACK_OCCASIONS = [
    { key: 'brunch', label: 'Brunch', description: 'Curated looks for slow mornings, garden brunches, and feeling effortlessly put together.', cover: null },
    { key: 'professional', label: 'Professional', description: 'Curated looks designed to help you feel confident before the meeting begins.', cover: null },
    { key: 'weekend', label: 'Weekend', description: 'Curated looks for slower days, easy plans, and effortless confidence.', cover: null },
    { key: 'evening', label: 'Evening', description: 'Curated looks for dinners, celebrations, and evenings worth remembering.', cover: null },
    { key: 'travel', label: 'Travel', description: 'Curated looks designed for every journey, from weekend escapes to long-awaited vacations.', cover: null },
    { key: 'everyday', label: 'Everyday', description: 'Versatile looks designed for the moments that make up everyday life.', cover: null }
  ];

  var QUERY = 'query SfyLooks($after:String){metaobjects(type:"carema_look",first:' + PAGE_SIZE + ',after:$after){pageInfo{hasNextPage endCursor}nodes{handle ' +
    'active:field(key:"active"){value} ' +
    'occ:field(key:"occasion_category"){value} ' +
    'ctx:field(key:"occasion_context"){value} ' +
    'sort:field(key:"sort_order"){value} ' +
    'headline:field(key:"headline"){value} ' +
    'internal:field(key:"internal_title"){value} ' +
    'sub:field(key:"subheadline"){value} ' +
    'eyebrow:field(key:"eyebrow"){value} ' +
    'cta:field(key:"cta_label"){value} ' +
    'problem:field(key:"problem_statement"){value} ' +
    'img:field(key:"editorial_image"){reference{...on MediaImage{image{url(transform:{maxWidth:800})}}}} ' +
    'main:field(key:"main_product"){value reference{...on Product{availableForSale}}} ' +
    'outfit:field(key:"outfit_products"){value}' +
    '}}}';

  var memoryLooks = null;
  var memoryTs = 0;
  var inflight = null;
  var occasionsCache = null;

  function normalize(s) {
    return String(s == null ? '' : s).trim().toLowerCase().replace(/\s+/g, '-');
  }

  function val(f) { return f && f.value != null ? String(f.value) : ''; }

  function pieceCount(mainGid, outfitRaw) {
    var ids = {};
    if (mainGid) ids[mainGid] = true;
    if (outfitRaw) {
      try {
        var arr = JSON.parse(outfitRaw);
        for (var i = 0; i < arr.length; i++) { if (arr[i]) ids[arr[i]] = true; }
      } catch (e) {}
    }
    return Object.keys(ids).length;
  }

  function mapNode(n) {
    var sortRaw = val(n.sort).trim();
    var sortNum = sortRaw === '' ? null : Number(sortRaw);
    if (sortNum !== null && isNaN(sortNum)) sortNum = null;
    var mainRef = n.main && n.main.reference ? n.main.reference : null;
    var headline = val(n.headline);
    return {
      handle: n.handle,
      active: val(n.active) === 'true',
      occ: normalize(val(n.occ)),
      ctx: normalize(val(n.ctx)),
      sortOrder: sortNum,
      headline: headline,
      title: headline || val(n.internal),
      sub: val(n.sub),
      eyebrow: val(n.eyebrow),
      ctaLabel: val(n.cta),
      problem: val(n.problem),
      image: n.img && n.img.reference && n.img.reference.image ? n.img.reference.image.url : '',
      pieceCount: pieceCount(val(n.main), val(n.outfit)),
      mainResolved: !!mainRef,
      mainAvailable: !!(mainRef && mainRef.availableForSale)
    };
  }

  function readCache() {
    try {
      var raw = window.sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var c = JSON.parse(raw);
      if (!c || !c.ts || !c.looks || (Date.now() - c.ts) > CACHE_TTL) return null;
      return c;
    } catch (e) { return null; }
  }

  function writeCache(looks, ts) {
    try { window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: ts, looks: looks })); } catch (e) {}
  }

  function fetchPage(after) {
    return fetch(STOREFRONT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN },
      body: JSON.stringify({ query: QUERY, variables: { after: after || null } })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.data || !d.data.metaobjects) throw new Error('SFY core: no data');
        return d.data.metaobjects;
      });
  }

  function fetchAll() {
    var acc = [];
    function step(after) {
      return fetchPage(after).then(function (conn) {
        (conn.nodes || []).forEach(function (n) { acc.push(mapNode(n)); });
        if (conn.pageInfo && conn.pageInfo.hasNextPage) return step(conn.pageInfo.endCursor);
        return acc;
      });
    }
    return step(null);
  }

  function load() {
    if (memoryLooks && (Date.now() - memoryTs) <= CACHE_TTL) return Promise.resolve(memoryLooks);
    var cached = readCache();
    if (cached) {
      memoryLooks = cached.looks;
      memoryTs = cached.ts;
      return Promise.resolve(memoryLooks);
    }
    if (inflight) return inflight;
    inflight = fetchAll().then(function (looks) {
      var ts = Date.now();
      memoryLooks = looks;
      memoryTs = ts;
      writeCache(looks, ts);
      inflight = null;
      return looks;
    }, function (err) {
      inflight = null;
      throw err;
    });
    return inflight;
  }

  function occasions() {
    if (occasionsCache) return occasionsCache;
    var list = null;
    try {
      var el = document.getElementById('sfy-occasions');
      if (el) {
        var parsed = JSON.parse(el.textContent || '[]');
        if (parsed && parsed.length) {
          list = parsed.map(function (o) {
            return { key: normalize(o.key), label: o.label || '', description: o.description || '', cover: o.cover || null };
          });
        }
      }
    } catch (e) { list = null; }
    occasionsCache = list || FALLBACK_OCCASIONS;
    return occasionsCache;
  }

  function getOccasion(key) {
    var k = normalize(key);
    var list = occasions();
    for (var i = 0; i < list.length; i++) { if (list[i].key === k) return list[i]; }
    return null;
  }

  function isEligible(look, occKey) {
    if (!look || !look.active || !look.mainAvailable) return false;
    if (occKey && look.occ !== occKey) return false;
    return true;
  }

  function findLook(looks, handle) {
    for (var i = 0; i < looks.length; i++) { if (looks[i].handle === handle) return looks[i]; }
    return null;
  }

  function coverState(looks, occKey) {
    var k = normalize(occKey);
    var occ = getOccasion(k);
    if (!occ || !occ.cover) return { state: 'none', look: null, handle: null };
    var l = findLook(looks, occ.cover);
    if (!l || !l.active || l.occ !== k || !l.mainResolved) return { state: 'invalid', look: l, handle: occ.cover };
    if (!l.mainAvailable) return { state: 'oos', look: l, handle: occ.cover };
    return { state: 'available', look: l, handle: occ.cover };
  }

  function compare(a, b) {
    var as = a.sortOrder, bs = b.sortOrder;
    if (as === null && bs !== null) return 1;
    if (bs === null && as !== null) return -1;
    if (as !== bs) return bs - as;
    return a.handle < b.handle ? -1 : (a.handle > b.handle ? 1 : 0);
  }

  function sequence(looks, occKey, opts) {
    var k = normalize(occKey);
    var ctx = normalize(opts && opts.context);
    var cs = coverState(looks, k);
    var out = [];
    if ((cs.state === 'available' || cs.state === 'oos') && (!ctx || cs.look.ctx === ctx)) {
      out.push({ look: cs.look, isCover: true, purchasable: cs.state === 'available' });
    }
    var rest = looks.filter(function (l) {
      if (cs.handle && l.handle === cs.handle) return false;
      if (!isEligible(l, k)) return false;
      if (ctx && l.ctx !== ctx) return false;
      return true;
    }).sort(compare);
    for (var i = 0; i < rest.length; i++) out.push({ look: rest[i], isCover: false, purchasable: true });
    return out;
  }

  function viewAll(looks, opts) {
    var ctx = normalize(opts && opts.context);
    return looks.filter(function (l) {
      return isEligible(l, null) && (!ctx || l.ctx === ctx);
    }).sort(compare).map(function (l) { return { look: l, isCover: false, purchasable: true }; });
  }

  function recommend(looks, occKey, opts) {
    var exclude = opts && opts.excludeHandle ? opts.excludeHandle : null;
    var seq = sequence(looks, occKey);
    for (var i = 0; i < seq.length; i++) {
      if (seq[i].purchasable && seq[i].look.handle !== exclude) return seq[i].look;
    }
    return null;
  }

  function neighbors(looks, occKey, currentHandle, max) {
    var limit = max || 8;
    var seq = sequence(looks, occKey).filter(function (it) { return it.purchasable; }).map(function (it) { return it.look; });
    var idx = -1;
    for (var i = 0; i < seq.length; i++) { if (seq[i].handle === currentHandle) { idx = i; break; } }
    var rotated = idx === -1 ? seq.slice() : seq.slice(idx + 1).concat(seq.slice(0, idx));
    var prev = null, next = null;
    if (rotated.length) {
      next = rotated[0];
      if (idx !== -1 && rotated.length > 1) prev = rotated[rotated.length - 1];
    }
    return { prev: prev, next: next, items: rotated.slice(0, limit), total: rotated.length, hasMore: rotated.length > limit };
  }

  function ctaLabel(look) {
    var n = look ? Number(look.pieceCount) : NaN;
    if (!isFinite(n) || n <= 0 || Math.floor(n) !== n) return 'Shop the Look';
    return 'Shop the ' + n + '-Piece Look';
  }

  window.CaremaSFY = {
    load: load,
    occasions: occasions,
    getOccasion: getOccasion,
    normalize: normalize,
    isEligible: isEligible,
    coverState: coverState,
    compare: compare,
    sequence: sequence,
    viewAll: viewAll,
    recommend: recommend,
    neighbors: neighbors,
    ctaLabel: ctaLabel
  };
})();
